import React from 'react';
import withAnalytics, { AnalyticsProps } from '../analytics';

type buttonType = 'button' | 'submit' | 'reset' | undefined;

export type ButtonProps = {
	className?: string;
	type: buttonType;
	onClick?: () => void;
	disabled?: boolean;
	children?: JSX.Element;
};

const ButtonComponent = ({
	type,
	onClick,
	disabled,
	children,
	className,
	...props
}: ButtonProps & AnalyticsProps & React.HTMLProps<HTMLButtonElement>) => {
	return (
		<button
			type={type}
			onClick={onClick}
			className={
				className ??
				'border-none py-3 px-10 text-font-cta text-lg bg-cta md:hover:bg-cta-hover active:bg-cta-hover focus:bg-cta-hover disabled:bg-cta-disabled  disabled:hover:bg-cta-disabled inline-flex justify-center cursor-pointer rounded-full font-semibold whitespace-nowrap mx-auto'
			}
			disabled={disabled}
			{...props}>
			{children}
		</button>
	);
};

export const Button = withAnalytics(ButtonComponent);

export default Button;
